// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"65491200","732":"ddccf1d0","977":"2ee5cf1f"}[chunkId] + ".chunk.js";
};